import React from 'react';
export function ClosingSection() {
  return <section className="py-24 px-6 bg-[var(--bg-deep)] text-center border-t border-[var(--bg-elevated)]" data-id="element-47">
      <div className="max-w-[680px] mx-auto space-y-8" data-id="element-48">
        <p className="text-xl md:text-2xl font-serif text-[var(--text-heading)] italic leading-relaxed" data-id="element-49">
          "Al final de estos 40 días, las circunstancias pueden ser las mismas.{' '}
          <br data-id="element-50" />
          Pero tú ya no serás el mismo."
        </p>

        <div className="w-16 h-px bg-[var(--accent)] mx-auto opacity-50" data-id="element-51"></div>

        <p className="text-[var(--text-muted)]" data-id="element-52">
          Porque habrás encontrado algo que el dolor no puede tocar: <br data-id="element-53" />
          la certeza de que hay una Roca que nada puede mover.
        </p>

        <div className="pt-8" data-id="element-54">
          <p className="text-[var(--accent)] font-bold tracking-widest uppercase text-xs" data-id="element-55">
            Eso es fe probada en el fuego.
          </p>
        </div>
      </div>
    </section>;
}